export default __webpack_public_path__ + "static/media/giantswarm.286068ba.svg";